var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "0%",
    x2: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F26221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5851F"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.503 4.356c.22-.219.28-.487.181-.802-.29-.875-.436-1.798-.436-2.771 0-.218-.072-.401-.218-.547-.145-.145-.328-.219-.547-.219H1.749c-.218 0-.402.074-.547.219C1.055.382.983.565.983.783c0 3.646 1.293 6.763 3.882 9.351 2.59 2.589 5.706 3.884 9.352 3.884.219 0 .401-.074.547-.219.146-.146.219-.328.219-.547v-2.735c0-.218-.073-.401-.219-.546-.146-.146-.328-.219-.547-.219-.973 0-1.895-.146-2.771-.438-.293-.121-.56-.06-.802.183L8.931 11.21C6.67 10.044 4.957 8.33 3.79 6.07l1.713-1.714z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M5.503 4.356c.22-.219.28-.487.181-.802-.29-.875-.436-1.798-.436-2.771 0-.218-.072-.401-.218-.547-.145-.145-.328-.219-.547-.219H1.749c-.218 0-.402.074-.547.219C1.055.382.983.565.983.783c0 3.646 1.293 6.763 3.882 9.351 2.59 2.589 5.706 3.884 9.352 3.884.219 0 .401-.074.547-.219.146-.146.219-.328.219-.547v-2.735c0-.218-.073-.401-.219-.546-.146-.146-.328-.219-.547-.219-.973 0-1.895-.146-2.771-.438-.293-.121-.56-.06-.802.183L8.931 11.21C6.67 10.044 4.957 8.33 3.79 6.07l1.713-1.714z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.78b6d02ac0259926973bde4851c14cd2.svg";
export { ForwardRef as ReactComponent };